/** Synchronous crash window before an outgoing frame reaches the local native staging table. */
const prefix = 'page-live-outbox'

export function journalLiveFrame(storage: Storage, userId: string, workspace: string, pageId: string, update: string) {
  const key = JSON.stringify([prefix, userId, workspace, pageId, crypto.randomUUID()])
  storage.setItem(key, update)
  return key
}

export function liveJournalFrames(storage: Storage, userId: string, workspace: string) {
  const records: { key: string; pageId: string; update: string }[] = []
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i)
    if (!key?.startsWith(`["${prefix}",`)) continue
    const parts = JSON.parse(key) as unknown[]
    if (parts[1] !== userId || parts[2] !== workspace || typeof parts[3] !== 'string') continue
    const update = storage.getItem(key)
    if (update !== null) records.push({ key, pageId: parts[3], update })
  }
  return records
}
